import ClaimYourCity from './claim-your-city'

export default ClaimYourCity
